import { atom } from 'jotai';

export const navAtom = atom('');
